import { OfflineProcessProgressProps, OfflineProcessProgress } from '../SurveyOfflineProgressModal'
import { ProgressBar } from '../../core/ProgressBar';

// ===============================================================================

// Use this inside private renderModals = () => { which is in CreateAndEditSurveys.tsx
//                <div>
//                    {this.props.surveyUi.activeSendOfflineProcessId !== null && <SurveyOfflineProgressModal offlineProcessId={this.props.surveyUi.activeSendOfflineProcessId} >}
//                </div>

export class SurveyAcceptProgressModal extends OfflineProcessProgress<OfflineProcessProgressProps> {
    public constructor(props: OfflineProcessProgressProps) {
        super(props);
    }

    // ===============================================================================

    public render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" data-id="offline-progress-x-close-button" className="close" aria-label="Close" onClick={e => this.doneButton_click(e)}><span aria-hidden="true">&times;</span></button>
                    <h4 className="modal-title">{this.props.appServices.localizeString("3E Exchange is accepting your supplier response")}</h4>
                </div>
                <div className="modal-body">
                    {this.renderInfoAlert()}
                    {this.renderQuotaExeededAlert()}
                    {this.renderStatusContainer("offline-accept-status-container")}
                </div>
                <div className="modal-footer">
                    <button type="button" data-id="offline-progress-close-button" className="btn btn-toxnot-primary" onClick={e => this.doneButton_click(e)}>{this.props.appServices.localizeString("Done")}</button>
                </div>
            </div>
        );
    }

    // ===============================================================================

    protected renderStatusContainer(id: string | null = null) {
        const isComplete = this.isComplete();

        return (
            <div id={id ?? ""} className={isComplete ? "progress-complete": ""}>
                {(isComplete && this.props.completeContent) ? this.props.completeContent : null}
                {(!isComplete && this.props.notCompleteContent) ? this.props.notCompleteContent : null}
                <ProgressBar localizedTitle={this.props.appServices.localizeString("Accepting response")} currentProgressIndex={this.state.currentProgressIndex} totalNumItems={this.state.totalItems} localizer={this.props.appServices} />
            </div>
        );
    }

    // ===============================================================================

    private renderInfoAlert() {
        if (!this.state.quotaExceeded) {
            return (
                <div className="alert alert-info">
                    <p className="text-center m-b-10-imp">
                        {this.props.appServices.localizeString("Depending on the size of the survey, this might take a couple minutes.")}
                    </p>
                    <p className="text-center">
                        {this.props.appServices.localizeString("You can safely leave this page and check back later by clicking the ‘My Surveys’ tab.")}
                    </p>
                </div>
            );
        }
    }

    // ===============================================================================

    private renderQuotaExeededAlert() {
        if (this.state.quotaExceeded) {
            return (
                <div className="alert alert-warning">
                    <p>
                        {this.props.appServices.localizeString("Sorry, your Products/Materials Library quota is full and you can't add any more items to your Library.")}
                    </p>
                    <p>
                        <a href="/Account/Upgrade" target="_blank">{this.props.appServices.localizeString("Check out your Subscription Page Here to see options.")}</a>
                    </p>
                </div>
            );
        }
    }

    // ===============================================================================

    private doneButton_click = (e: any) => {
        e.persist();

        const $modal = $(e.target).closest(".modal");

        this.stopPolling();

        $modal.modal("hide");
    }
}